import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { Participant } from '@typings/participant';

type InitialState = {
  byId: Record<string, Participant>;
};

export const initialState: InitialState = {
  byId: {},
};

export const participantsSlice = createSlice({
  name: 'participants',
  initialState,
  reducers: {
    setParticipantDataById: (
      state,
      action: PayloadAction<Partial<Participant>>,
    ) => {
      const oldParticipantData = state.byId[action.payload.id!] || {};
      state.byId[action.payload.id!] = {
        ...oldParticipantData,
        ...action.payload,
      };
    },
    setParticipantsData: (state, action: PayloadAction<Participant[]>) => {
      action.payload.forEach((participant) => {
        const previousData = state.byId[participant.id] || {};
        state.byId[participant.id] = { ...previousData, ...participant };
      });
    },
  },
});

export const { setParticipantDataById, setParticipantsData } =
  participantsSlice.actions;

export default participantsSlice.reducer;
